import styled from "styled-components";

export const WeatherItemContainer = styled.div`
    margin: 0 12px 12px;
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
    overflow: hidden;

    .itemTitle {
        padding: 14px 16px 10px;
        font-family: S-Core-Dream;
        font-size: 15px;
        font-weight: 600;
        color: #212529;
    }

    .weatherRow {
        display: flex;
        border-top: 1px solid #e9ecef;
    }

    .divider {
        width: 1px;
        background: #e9ecef;
        margin: 12px 0;
    }

    .weatherSide {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px 8px 14px;
        cursor: pointer;
        transition: background 0.15s;
        gap: 4px;

        &.active {
            background: #f0f6ff;
        }
    }

    .timeLb {
        font-size: 12px;
        color: #6c757d;
        font-family: Roboto;
        display: inline-flex;
        align-items: center;
        gap: 5px;

        .regionMark {
            display: flex;
            line-height: 0;
        }
    }

    .weatherContent {
        display: flex;
        align-items: center;
        gap: 22px;
    }

    .iconWrap {
        flex-shrink: 0;
    }

    .dataWrap {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    .tempLb {
        font-family: Roboto;
        font-size: 20px;
        color: #212529;
        line-height: 1.2;
        sup { font-size: 11px; }
    }

    .rainLb {
        font-family: Roboto;
        font-size: 15px;
        color: #6c757d;
        line-height: 1.2;
        sup { font-size: 10px; }
    }

    .precipLb {
        font-family: Roboto;
        font-size: 13px;
        color: #6c757d;
        line-height: 1.2;
    }

    /* 상세 패널 */
    .detailPanel {
        background: #f8f9fa;
        border-top: 1px solid #e9ecef;
        padding: 14px 16px;
        animation: slideDown 0.2s ease-out;
    }
    @keyframes slideDown {
        from { opacity: 0; max-height: 0; }
        to { opacity: 1; max-height: 200px; }
    }
    .detailHeader {
        font-family: S-Core-Dream;
        font-size: 13px;
        font-weight: 600;
        color: #0d6efd;
        margin-bottom: 10px;
    }
    .detailGrid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 8px 20px;
        > div {
            display: flex;
            justify-content: space-between;
            font-size: 13px;
        }
        .detailLabel { color: #6c757d; font-family: S-Core-Dream; }
        .detailValue { font-family: Roboto; font-weight: 500; color: #212529; }
    }
`;
